<script setup lang="ts">
type Notification = { type: string; message: string; id?: number }

const emit = defineEmits<{
  (e: 'click:close', id: number): void
}>()

const props = defineProps<{
  notification: Notification
}>()

const handleClose = () => {
  if (props.notification.id !== undefined) {
    emit('click:close', props.notification.id)
  }
}
</script>
<template>
  <div class="site-notification f-18" :class="props.notification.type">
    <Icon v-if="props.notification.type === 'danger'" name="alert" />
    <Icon v-if="props.notification.type === 'success'" name="check" />
    <span class="site-notification__message" v-html="notification.message" />
    <button
      v-if="notification.id !== undefined"
      class="site-notification__close"
      aria-label="Close notification"
      @click="handleClose"
    >
      <Icon name="mini-close-medium" />
    </button>
  </div>
</template>
